import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  IconButton,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { Fragment, useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { deleteFamilyHistory, getFamilyHistoryData } from "../../../services";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { FamilyHistoryContext, contextType } from "./FamilyHistory";
import FamilyHistoryForm from "./FamilyHistoryForm";
import { useParams } from "react-router-dom";
import { IcdListType } from "./type";
import moment from "moment";
import LogComonent from "../../layouts/LogComonent";
import usePopup from "../../../../hooks/usePopup";
import { HL7ContexTriggerContex } from "../../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import { Close } from "@mui/icons-material";
import EmptyListAlert from "../../layouts/EmptyListAlert";

function FamilyHistoryTable() {
  const [show, setShow] = useState(false);
  const { showSnackbar } = usePopup()
  const [selected, setSelected] = useState(-1)
  const { patientId, encounterId } = useParams();
  const { setTrigger } = useContext(HL7ContexTriggerContex)
  const { tableData, setEdit, edit, setTableData, success } = useContext(
    FamilyHistoryContext
  ) as contextType;
  const { mutate } = useMutation(getFamilyHistoryData, {
    onSuccess: (data) => {
      setTableData([...data.response]);
    },
  });
  const { mutate: deleteFamily, isLoading: deleteLoading } = useMutation(deleteFamilyHistory, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        mutate(parseFloat(patientId as string));
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 2000
        })
        setTrigger({
          tab: "familyhistory",
          encounterId: encounterId as string
        })
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 2000
        })
      }
    },
    onError: () => {
      showSnackbar({
        message: "Something went wrong !",
        open: true,
        variant: "warning",
        duration: 2000
      })
    }
  });


  const handleEdit = (data: any) => {
    setEdit({
      ...data,
    });
    setShow(false);
  };
  const handleDelete = (id: number) => {
    if (encounterId) {
      deleteFamily({ encounterId, id });
    }
  };

  const handleClose = () => {
    setEdit(null)
  }

  useEffect(() => {
    mutate(parseFloat(patientId as string));
  }, [success]);
  return (
    <Paper>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow
              sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
            >
              {heading.map((heading, index) => (
                <TableCell
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                  align="left"
                  key={`heading${index}`}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                <EmptyListAlert alert="No family history" isData={Boolean((tableData?.length || show))} children={!show && (
                  <div className="w-full flex justify-end items-center p-2 gap-3">
                    <Button
                      color="success"
                      endIcon={<AddCircleIcon />}
                      onClick={() => {
                        setShow(true);
                        setEdit(null);
                      }}
                    >
                      add
                    </Button>
                    <div>
                      {/* <LogComonent  />
                      <HistoryComponent logProps={{ title: "Family History", field: "familyhistory" }} title="Family History" tableprops={tableProps} /> */}
                    </div>
                    <LogComonent field="familyhistory" title="Family history" />
                  </div>
                )} />
                <Collapse in={show} timeout="auto" unmountOnExit>
                  <Box>
                    <FamilyHistoryForm
                      close={() => {
                        setShow(false);
                      }}
                    />
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
            {tableData?.map((item: IcdListType, index: number) => (
              <Fragment key={index}>
                <TableRow >
                  {/* {`${item.Relation.description}(${item.icdCode.icd_des})`} */}
                  <TableCell>
                    <ListItemText
                      primary={`${item?.icd.icdCode}`}
                      secondary={
                        <Tooltip title={item.notes || ""} arrow placement="right">
                          <Typography
                            component="div"
                            variant="body2"
                            sx={{
                              color: "text.primary",
                              maxWidth: 250,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              cursor: "pointer"
                            }}
                          >
                            notes - {item.notes}
                          </Typography>
                        </Tooltip>
                      }
                    ></ListItemText>
                  </TableCell>
                  <TableCell>{item.icd.icdDescription}</TableCell>
                  <TableCell>{item.relation.description}</TableCell>
                  <TableCell>{`${item.fromdate ? moment(item.fromdate).format("DD-MM-YYYY") : ""} - ${item.todate ? moment(item.todate).format("DD-MM-YYYY") : ""}`}</TableCell>

                  <TableCell>
                    {edit?.id == item?.id ? <IconButton onClick={handleClose} color="error">
                      <Close />
                    </IconButton> : <IconButton
                      color="primary"
                      onClick={() => {
                        handleEdit(item);
                      }}
                    >
                      <EditIcon />
                    </IconButton>}
                    {(deleteLoading && selected == index) ? <CircularProgress size={18} color="error" /> : <IconButton
                      color="error"
                      onClick={() => {
                        handleDelete(item.id);
                        setSelected(index)
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                    <Collapse
                      in={
                        Boolean(edit) &&
                        edit?.id == item?.id
                      }
                      timeout="auto"
                      unmountOnExit
                    >
                      <FamilyHistoryForm
                        close={() => {
                          setEdit(null);
                        }}
                      />
                    </Collapse>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
export default FamilyHistoryTable;
const heading = ["ICD CODE/NOTES", "ICD DESCRIPTION", "RELATION", "DURATION", "OPTIONS"];

// const tableProps = [
//   { heading: "ICD CODE", key: "icd.icdCode" },
//   { heading: "ICD DESCRIPTION", key: "icd.icdDescription" },
//   { heading: "RELATION", key: "relation.description" },
//   { heading: "FROM DATE", key: "fromdate" },
//   { heading: "TO DATE", key: "todate" },
//   { heading: "NOTES", key: "notes" },

// ]
